import { TEXT } from 'locales/translations';
import { Paragraph } from 'Common';

export const PostalCodeHint = () => <Paragraph className="extra-small">{TEXT.formsGeneral.requiredPostalCodeCheck}</Paragraph>;
